import { CSSProperties, FunctionComponent, memo, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { SPLogoIcon, TuttiLogoIcon } from '../index';

type ComponentLoaderProps = {
    animate?: boolean;
    height?: CSSProperties['height'];
};
export const LogoSVG = styled('object')<ComponentLoaderProps>`
    @keyframes rotateDrum {
        0% {
            transform: rotate(0deg);
            scale: 1;
        }
        50% {
            transform: rotate(360deg);
            scale: 0.8;
        }
        100% {
            transform: rotate(360deg);
            scale: 1;
        }
    }

    max-height: 5rem;
    width: 100%;
    height: 100%;
    ${({ animate }) => animate && 'animation: rotateDrum 1s linear infinite;'}
`;

const LogoContainer = styled('div')<ComponentLoaderProps>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: ${({ height }) => height};
    max-height: 100%;
    width: 100vw;
    max-width: 100%;
`;

const ContentLoader: FunctionComponent<ComponentLoaderProps> = ({ animate = true, height = 'calc(100vh - 120px)' }) => {
    const isStyreportalen = useMemo(() => {
        return window.location.hostname === process.env.sentral_hostname;
    }, []);

    return (
        <LogoContainer className={'content-loader'} height={height}>
            <LogoSVG type="image/svg+xml" animate={animate} data={isStyreportalen ? SPLogoIcon : TuttiLogoIcon} />
        </LogoContainer>
    );
};

export default memo(ContentLoader);
